import {
    FILTER_QUOTATION_DATA,
    GET_DASHBOARD_INQUIRY_SUMMARY_DATA_SUCCESS,
    GET_INQUIRY_CUSTOMER_SUMMARY_DATA_SUCCESS,
    GET_INQUIRY_DATA_FAIL,
    GET_INQUIRY_DATA_LOADER,
    GET_INQUIRY_DATA_SUCCESS,
    GET_INQUIRY_EXPORT_SUMMARY_DATA_SUCCESS,
    GET_INQUIRY_IMPORT_SUMMARY__DATA_SUCCESS,
    GET_INQUIRY_SALES_CUSTOMER_SUMMARY_DATA_SUCCESS,
    GET_INQUIRY_SUMMARY_DATA_SUCCESS,
    GET_QUOTATION_DATA_FAIL,
    GET_QUOTATION_DATA_SUCCESS,
    GET_QUOTATION_HISTORY_DATA_SUCCESS,
    GET_QUOTATION_RESULT_FAIL,
    GET_QUOTATION_RESULT_SUCCESS,
    SEARCH_QUOTATION_BLANK,
    UPDATE_CONTAINERTYPE_CONFIRM,
    UPDATE_CONTAINER_CHANGE,
    UPDATE_SEARCH_QUOTATION_DATA,
    UPDATE_SEARCH_QUOTATION_DATE,
    UPDATE_SEARCH_QUOTATION_SWAP,
    UPDATE_VALUE_BLANK,
    GET_QUOTATION_SELLER_DETAILS_LIST_SUCCESS,
    GET_NETWORK_INQUIRIES_SUMMARY_SUCCESS, GET_NETWORK_INQUIRIES_BIDS_SUMMARY_SUCCESS,
    GET_NETWORK_ACTIVE_INQUIRIES_DETAILS_SUCCESS, GET_NETWORK_FREIGHT_LEADS_STATS_SUCCESS,
    BOOKINGS_STATUS_LOADER,
    BOOKINGS_STATUS_REQUEST_SUCCESS,
    BOOKINGS_STATUS_REQUEST_FAIL,
    BOOKINGS_STATUS_INIT,
    GET_ALL_QUOTATION_COMPARISON_DATA_SUCCESS
} from "./actiontype"
import { GET_TENANT_FCL_QUOTATION_SUMMERY_BY_ID_ERROR, POST_TRANSFER_STATUS_IS_LODING, POST_TRANSFER_STATUS_IS_SUCCESS_LODING } from "./Quotation/actiontype"


const INIT_STATE = {
    quotation_data: [],
    quotation_error: {},
    createFields: {
        // customer_name: '',
        // service_type: '',
        // incoterm: '',
        shipping_by: '',
        container_type: '',
        cargo_weight: { weight: "MT", value: '' },
        cargo_type: '',
        cargo_value: { currency: { name: 'Rupee', value: 'rupee', code: '₹' }, value: '' },
        cargo_date: '',
        location_from: '',
        location_to: '',
    },

    inquiry_data: [],
    inquiry_error: [],
    inquiry_export_data: [],
    inquiry_import_data: [],
    inquiry_customer_data: [],
    inquiry_summary_data: [],
    inquiry_sales_customer_data: [],
    inquiry_data_loader: false,
    inquiry_transfer_status_data_loader: {},
    is_transfer_status_loader: false,
    dashboard_inquery_summery: [],
    quotation_history_data: [],
    quotation_seller_history_list: [],
    networkInquiries: [],
    ViewBidsSummaryData: [],
    activeQuotationsViewDetails: '',
    dashboardFreightLeadStatsData: '',
    viewBidsBreakdownError: false,
    getInstantBookingRequestDataLoader: false,
    getInstantBookingRequestData: [],
    getBookingStatusLoader: false,
    getBookingStatusUpdateSuccess: false,
    getBookingStatusUpdateFail: false,
    getBookingStatusFailData: '',
    quotation_comparison_data:{}
}

const sales = (state = INIT_STATE, action) => {
    switch (action.type) {
        case BOOKINGS_STATUS_INIT:
            return {
                ...state,
                activeQuotationsViewDetails: '',
                getBookingStatusLoader: false,
                getBookingStatusUpdateSuccess: false,
                getBookingStatusUpdateFail: false,
                getBookingStatusFailData: '',
            }
        case BOOKINGS_STATUS_LOADER:
            // Only reset success/fail flags when starting the loader, not when ending it
            return {
                ...state,
                getBookingStatusLoader: action.payload,
            }
        case BOOKINGS_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                getBookingStatusUpdateSuccess: true,
                getBookingStatusUpdateFail: false,
            }
        case BOOKINGS_STATUS_REQUEST_FAIL:
            return {
                ...state,
                getBookingStatusUpdateSuccess: false,
                getBookingStatusUpdateFail: true,
                getBookingStatusFailData: action.payload,
            }
        case GET_NETWORK_FREIGHT_LEADS_STATS_SUCCESS:
            return {
                ...state,
                dashboardFreightLeadStatsData: action.payload
            }
        case GET_ALL_QUOTATION_COMPARISON_DATA_SUCCESS:
            return {
                ...state,
                quotation_comparison_data: action.payload
            }
        case GET_NETWORK_ACTIVE_INQUIRIES_DETAILS_SUCCESS:
            return {
                ...state,
                activeQuotationsViewDetails: action.payload
            }
        case GET_QUOTATION_SELLER_DETAILS_LIST_SUCCESS:
            return {
                ...state,
                quotation_seller_history_list: action.payload,
            }
        case GET_NETWORK_INQUIRIES_BIDS_SUMMARY_SUCCESS:
            return {
                ...state,
                ViewBidsSummaryData: action.payload,
            }
        case GET_QUOTATION_DATA_SUCCESS:
            return { ...state, quotation_data: action.payload }
        case FILTER_QUOTATION_DATA:
            return { ...state, quotation_data: action.payload }

        case GET_INQUIRY_CUSTOMER_SUMMARY_DATA_SUCCESS:
            return { ...state, inquiry_customer_data: action.payload }

        case GET_INQUIRY_SALES_CUSTOMER_SUMMARY_DATA_SUCCESS:
            return { ...state, inquiry_sales_customer_data: action.payload }

        case GET_INQUIRY_EXPORT_SUMMARY_DATA_SUCCESS:
            return { ...state, inquiry_export_data: action.payload }

        case GET_INQUIRY_IMPORT_SUMMARY__DATA_SUCCESS:
            return { ...state, inquiry_import_data: action.payload }

        case GET_INQUIRY_SUMMARY_DATA_SUCCESS:
            return { ...state, inquiry_summary_data: action.payload }

        case GET_QUOTATION_DATA_FAIL:
            return { ...state, quotation_error: action.payload }

        case GET_NETWORK_INQUIRIES_SUMMARY_SUCCESS:
            return { ...state, networkInquiries: action.payload }

        case UPDATE_SEARCH_QUOTATION_DATA:
            const { item, name } = action.payload
            return {
                ...state,
                createFields: {
                    ...state.createFields,
                    [name]: item
                }
            }

        case UPDATE_SEARCH_QUOTATION_DATE:
            const { arrItem } = action.payload
            let newObj = {
                ...state,
                createFields: {
                    ...state.createFields,
                    cargo_date: [...arrItem],
                }
            }
            return state = newObj

        case UPDATE_SEARCH_QUOTATION_SWAP:
            return {
                ...state,
                createFields: {
                    ...state.createFields,
                    location_to: state.createFields.location_from,
                    location_from: state.createFields.location_to
                }
            }

        case UPDATE_CONTAINERTYPE_CONFIRM:
            return state = {
                ...state,
                createFields: {
                    ...state.createFields,
                    container_type: action.payload,
                }
            }
        case UPDATE_CONTAINER_CHANGE:
            return {
                ...state,
                createFields: {
                    ...state.createFields,
                    container_type: action.payload
                }
            }
        case UPDATE_VALUE_BLANK:
            return {
                ...state,
                createFields: {
                    ...state.createFields,
                    [action.payload]: ''
                }
            }

        case SEARCH_QUOTATION_BLANK:
            return {
                ...state,
                createFields: {
                    shipping_by: '',
                    cargo_type: '',
                    cargo_weight: { weight: "MT", value: '' },
                    container_type: '',
                    cargo_value: { currency: { name: 'Rupee', value: 'rupee', code: '₹' }, value: '' },
                    cargo_date: '',
                    location_from: '',
                    location_to: '',
                },
            }

        // inquiry
        case GET_INQUIRY_DATA_SUCCESS:
            console.log(action.payload, "action.payload")
            return { ...state, inquiry_data: action.payload }

        case GET_INQUIRY_DATA_LOADER:
            return { ...state, inquiry_data_loader: action.payload }

        case GET_INQUIRY_DATA_FAIL:
            return { ...state, inquiry_data: action.payload }

        case POST_TRANSFER_STATUS_IS_SUCCESS_LODING:
            return { ...state, inquiry_transfer_status_data_loader: action.payload }

        case POST_TRANSFER_STATUS_IS_LODING:
            return { ...state, is_transfer_status_loader: action.payload }
        case GET_DASHBOARD_INQUIRY_SUMMARY_DATA_SUCCESS:
            return { ...state, dashboard_inquery_summery: action.payload }
        case GET_QUOTATION_HISTORY_DATA_SUCCESS:
            return { ...state, quotation_history_data: action.payload }
        case GET_TENANT_FCL_QUOTATION_SUMMERY_BY_ID_ERROR:
            return { ...state, viewBidsBreakdownError: action.payload }
        default:
            return state;
    }
}

export default sales
